export default __webpack_public_path__ + "static/media/skill.d6a590a3.png";